import { FormikHelpers } from "formik";
import OteFpaForm from "./OteFpaForm";
import { useGetOteFpa } from "./api/getOteFpa";
import { useEditOteFpa } from "./api/editOteFpa";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditOteFpa = ({handleCloseModal, oteFpaId}: EditOteFpaProps)  => {
  const getOteFpaQuery = useGetOteFpa({oteFpaId: oteFpaId})
  const editOteFpaMutation = useEditOteFpa({data: {}, oteFpaId});

  const handleSubmit = async (values: IPostEditOteFpa, { setSubmitting }: FormikHelpers<IPostEditOteFpa>): Promise<void> => {
    try {
      await editOteFpaMutation.mutateAsync({
        data: values,
        oteFpaId: oteFpaId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    }finally{
      setSubmitting(false);
    }
  }

  if (getOteFpaQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getOteFpaQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Κατηγορίας ΦΠΑ.</div>
    )
  }

  return (
    <>
      {!getOteFpaQuery.isLoading && getOteFpaQuery.data &&
        <OteFpaForm initialValues={getOteFpaQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditOteFpaProps {
  oteFpaId: number;
  handleCloseModal: () => void;
}

export default EditOteFpa;